<template>
  <div>
    <router-view></router-view>
    <div class="footer">
      <div class="width1200 el-row--flex is-justify-space-between">
        <div class="footer-box">
          <div class="footer-box-title">关于我们</div>
          <div class="footer-box-item" @click="to('/aboutus/#brief')">公司简介</div>
          <div class="footer-box-item" @click="to('/aboutus/#culture')">企业文化</div>
          <div class="footer-box-item" @click="to('/aboutus/#course')">发展历程</div>
          <div class="footer-box-item" @click="to('/aboutus/#qualification')">荣誉资源</div>
        </div>
        <div class="footer-box">
          <div class="footer-box-title">产品中心</div>
          <div class="footer-box-item" @click="to('/product')">网络货运服务平台</div>
          <div class="footer-box-item" @click="to('/product/etc')">ETC数据服务平台</div>
          <div class="footer-box-item" @click="to('/product/wms')">WMS仓储管理平台</div>
          <div class="footer-box-item" @click="to('/product/tms')">TMS物流管理平台</div>
        </div>
        <div class="footer-box">
          <div class="footer-box-title">解决方案</div>
          <div class="footer-box-item">货主企业</div>
          <div class="footer-box-item">物流企业</div>
        </div>
        <div class="footer-box">
          <div class="footer-box-title">新闻动态</div>
          <div class="footer-box-item" @click="to('/news?tab=1')">企业动态</div>
          <div class="footer-box-item" @click="to('/news?tab=2')">行业动态</div>
        </div>
        <div class="footer-box">
          <div class="footer-box-title">联系我们</div>
          <div class="footer-box-item el-row--flex is-align-middle">
            <img class="right8" src="/static/images/icon/icon-foot-phone.png" >
            0571-8381-7082
          </div>
          <div class="footer-box-item el-row--flex is-align-middle">
            <img class="right8" src="/static/images/icon/icon-foot-email.png" >
            adm@cywy56.com
          </div>
        </div>
        <div class="footer-box">
          <div class="footer-box-title"></div>
          <div class="footer-box-item haveImg">
            <img src="/static/images/qrcode-App.png" >
            <div>成易网运App</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        //
      }
    },
    methods: {
      to(path) {
        if (this.$router.history.current.path != path) {
          this.$router.push(path);
        } else {
          location.reload();
        }
      }
    },
    watch: {
      $router(e, n) {
        console.log(e,n);
      }
    }
  }
</script>

<style lang="scss">
  .footer {
    position: relative;
    padding: 43px 0 24px;
    font-size: 18px;
    color: #fff;
    background-color: #202930;
    z-index: 10;

    &-box-title {
      height: 56px;
      padding: 19px 0;
      border-bottom: 1px solid #353f48;
      box-sizing: border-box;
      text-align: left;
    }

    &-box-item {
      width: 200px;
      padding: 12px 0;
      font-size: 15px;
      color: #999;
      text-align: left;
      cursor: pointer;

      &.haveImg {
        text-align: center;
        color: #fff;

        img {
          margin-bottom: 11px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/foot.vue